// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iZKnk","col":"styles_col__cpx6v"};